/*  Shared  */
import { Dashboard } from 'application/Shared/Components/Dashboard';

/*  Types  */
import { Dashboard as DashboardType } from 'application/Shared/Components/Dashboard/types';

/*  React  */
import React from 'react';

/*  Data  */
import adminDashboard from './reportsAdmin.json';
import partnerDashboard from './reportsPartner.json';

export const ReportsDashboard = ({ type }: { type: 'admin' | 'partner' }) => {
    const dashboard = type === 'admin' ? adminDashboard : partnerDashboard;

    return <Dashboard dashboard={dashboard as DashboardType} />;
};
